import { updateProfileAction } from '../update'
import { PROFILES_ACTION } from '../../constants'
import { PROFILE_KEY } from '../../../../../models/profile/constants'

export function updateBodyTypeProfileAction (value) {
  return updateProfileAction({
    type: PROFILES_ACTION.UPDATE_BODY_TYPE,
    payload: {
      key: PROFILE_KEY.BODY_TYPE,
      value
    }
  })
}
